(() => {
  var a;
  a = window.jQuery, window, document, a((function() {
    a(".tour-page__details .nav-tabs.nav-tabs--duplicated .nav-item").on({
      click: function(i) {
        var e = a(".tour-page__details .nav-tabs").first();
        a("html, body").animate({
          scrollTop: e.offset().top - 10
        }, 800)
      }
    })
  }))
})(),
  function(a) {
    a((function() {
      a(".galleria-stage").each((function() {
        var i = a(this),
          e = i.data("gallery-index"),
          t = a("<div>", {
            class: "galleria-counter"
          }),
          l = function(a) {
            var i = a.slickCurrentSlide() + 1,
              e = a.slideCount;
            t.text("".concat(i, " / ").concat(e))
          };
        
        // Skip if no images in gallery
        if (i.find("img").length === 0) {
          return;
        }
        
        i.on("init", (function(e, n) {
          // console.log("=== INIT START ==="), console.log("CURRENT .galleria-stage:", i[0]);
          if (!n.$slides || n.$slides.length === 0) return;
          var o = i.parents(".image-or-slider").first(),
            s = a(n.$slides[0]).find("img").attr("title"),
            r = o.find(".galleria-info-title"),
            d = o.find(".galleria-info-text"),
            c = o.find(".galleria-info");
          r.text(s), i.append(t), l(n), i.on("afterChange", (function(e, t, n) {
            // console.log("=== AFTER CHANGE ==="), console.log("CURRENT .galleria-stage:", i[0]);
            var o = a(t.$slides[n]).find("img").attr("title");
            o ? (r.text(o), d.show(), c.show()) : (d.hide(), c.hide()), l(t)
          }))
        })), i.slick({
          slidesToShow: 1,
          lazyLoad: "ondemand",
          slidesToScroll: 1,
          arrows: !0,
          pauseOnHover: !1,
          pauseOnFocus: !1,
          fade: !1,
          speed: 640,
          infinite: !0,
          cssEase: "linear",
          autoplay: !1,
          accessibility: !1,
          swipe: !0,
          touchThreshold: 15,
          swipeToSlide: !1,
          initialSlide: 0,
          asNavFor: '.galleria-thumbnails-list[data-gallery-index="'.concat(e, '"]')
        });
        var n = i.parents(".tour-page__gallery").length,
          o = {
            slidesToShow: n ? 5 : 3.5,
            slidesToScroll: 1,
            speed: 640,
            arrows: !0,
            initialSlide: 0,
            lazyLoad: !n && "ondemand",
            asNavFor: '.galleria-stage[data-gallery-index="'.concat(e, '"]'),
            focusOnSelect: !0
          };
        a('.galleria-thumbnails-list[data-gallery-index="'.concat(e, '"]')).slick(o), i.on("afterChange", (function(e, t, n) {
          // console.log("=== AFTER CHANGE ==="), console.log("CURRENT .galleria-stage:", i[0]);
          var o = a(t.$slides[n]).find("img").attr("title"),
            s = i.parents(".image-or-slider").first(),
            r = s.find(".galleria-info-text"),
            d = s.find(".galleria-info"),
            c = s.find(".galleria-info-title");
          o ? (c.text(o), r.show(), d.show()) : (r.hide(), d.hide()), l(t)
        })), a(".tab-pane > button").on("click", (function() {
          setTimeout((function() {
            return i.slick("setPosition")
          }), 500)
        }))
      }))
    }))
  }(jQuery);
